import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { autoinject } from 'aurelia-framework';
import { CustomNumberFormatterBaseValueConverter } from './CustomNumberFormatterBase';
import * as replace from 'gulp-replace';

@autoinject
export class TrackChangesFormatBaseValueConverter {

    protected i18n: I18N = null;
    constructor(i18n: I18N) {
        this.i18n = i18n;
    }
    toView(value, type) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            switch (type) {
                case 1: return value.toLowerCase() == 'true' ? this.i18n.tr('Yes') : this.i18n.tr('No');
                case 2: return this.NumberFormat(value);
                case 3:
                case 4:
                    {
                        const customNumberFormatter = new CustomNumberFormatterBaseValueConverter(this.i18n);
                        return customNumberFormatter.toView(value.replace(',', '.'), null, null, type, null);
                    }
                case 7: return moment(value).format('l');
                case 11: return moment(value).format('LT');
                case 12: {
                    let time = moment(value, 'MM/DD/YYYY hh:mm A');
                    return time.format('l LT');
                }
                case 9988: {
                    return moment(value).format('LT');
                }
                case 9999: {
                    return moment(value).format('l LT');
                }
                case 35: {
                    return intlTelInputUtils.formatNumber(value, null, intlTelInputUtils.numberFormat.INTERNATIONAL);
                }
                default: return value;
            }
        }
        return value;
    }
    private NumberFormat = (x) => {
        return Intl.NumberFormat(this.i18n.getLocale().toLowerCase().substring(0, 2)).format(x);
    }
}